var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 371.725,
    height: 286.018,
    viewBox: "0 0 371.725 286.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6893",
    "data-name": "Path 6893",
    d: "M257.664,132.082s6.4,20.548,16.114,25.858c-.213-7.046-.463-13.665-.552-17.952-.25-11.855-17.29-22.475-34.566-19.762s-26.182,12.841-25.2,22.233c0,0-.081,6.45-.074,14.635C221.73,153.5,243.69,143.481,257.664,132.082Z",
    transform: "translate(-213.389 -119.798)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6898",
    "data-name": "Path 6898",
    d: "M272.787,232.357s0,8.958-6.715,23.233-7,28.55-2.523,39.185,16.518,14.841,29.418,10.083,14.555-26.035,13.157-38.913-13.974-27.991-16.8-35.552-4.758-11.473-4.758-11.473S277.288,229,272.8,231.231Z",
    transform: "translate(-260.547 -218.92)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028",
    transform: "matrix(0.875, -0.485, 0.485, 0.875, -16097.079, -7078.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024",
    transform: "translate(-184 192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    "data-name": "Path 6788",
    d: "M329.577,127.774l38.126,2.368a8.414,8.414,0,0,1,7.891,8.509L375.4,153.97l11.083,1.177-11.172,5.766a8.413,8.413,0,0,1-8.568,8.3l-37.015-.677a8.414,8.414,0,0,1-8.252-8.09l-.853-23.946a8.406,8.406,0,0,1,8.95-8.722Z",
    transform: "translate(10503.295 13831.488)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    width: 24.969,
    height: 15.724,
    transform: "translate(10837.348 13963.219)",
    fill: "#8c8c8c",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1347",
    "data-name": "Rectangle 1347",
    width: 14.179,
    height: 15.724,
    transform: "translate(10848.137 13963.219)",
    fill: "#696969",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1348",
    "data-name": "Rectangle 1348",
    width: 10.171,
    height: 15.724,
    transform: "translate(10844.746 13963.219)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    d: "M353.3,169.253v-3.993a3.422,3.422,0,0,1,6.825-.059c0,.088-.074.147-.184.162l-.655.044c-.118,0-.191,0-.191-.088v-.088a2.383,2.383,0,1,0-4.766,0V169.3a2.383,2.383,0,1,0,4.766,0,.154.154,0,0,1,.191-.162h.655c.11,0,.184,0,.184.074v.074a3.421,3.421,0,0,1-6.825-.029Z",
    transform: "translate(10483.863 13822.413)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6790",
    "data-name": "Path 6790",
    d: "M365.229,162.928a.787.787,0,1,1,.787.735.735.735,0,0,1-.787-.735Zm.279,9.237v-6.972a.177.177,0,0,1,.184-.191h.655a.177.177,0,0,1,.191.191v6.972a.176.176,0,0,1-.191.191h-.655a.177.177,0,0,1-.184-.191Z",
    transform: "translate(10480.708 13822.405)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6791",
    "data-name": "Path 6791",
    d: "M375.4,168.342v4.839a.176.176,0,0,1-.184.191h-.655a.176.176,0,0,1-.191-.191v-.522c0-.059-.044-.088-.088,0a3.074,3.074,0,0,1-2.265.86,2.11,2.11,0,0,1-2.4-2.125c0-1.53,1.1-2.353,2.993-2.353h1.7a.066.066,0,0,0,.074-.074v-.537a1.471,1.471,0,0,0-1.7-1.6c-.919,0-1.515.375-1.677.986a.169.169,0,0,1-.213.147l-.735-.088c-.118,0-.191-.059-.177-.154.191-1.066,1.265-1.795,2.765-1.795C374.43,165.9,375.4,166.908,375.4,168.342Zm-1.03,2.677V169.9a.066.066,0,0,0-.074-.074h-1.522c-1.265,0-2.125.537-2.125,1.471s.735,1.287,1.6,1.287c1.081.015,2.125-.552,2.125-1.566Z",
    transform: "translate(10479.546 13821.39)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6792",
    "data-name": "Path 6792",
    d: "M380.275,171.461a6.283,6.283,0,0,1-.206-1.787,6.619,6.619,0,0,1,.191-1.772,3.015,3.015,0,0,1,5.678,0,6.419,6.419,0,0,1,.206,1.787,6.281,6.281,0,0,1-.206,1.787,2.993,2.993,0,0,1-5.663,0Zm4.707-.3a6.774,6.774,0,0,0,.118-1.471,6.17,6.17,0,0,0-.118-1.471,1.949,1.949,0,0,0-3.751,0,9.206,9.206,0,0,0,0,2.942,1.949,1.949,0,0,0,3.751,0Z",
    transform: "translate(10476.782 13821.396)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026",
    transform: "translate(35 107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    d: "M160.078,140.965,145,136.891l3.405-22.35a7.1,7.1,0,0,0-7.6-8.149L108.8,109.039a7.09,7.09,0,0,0-6.494,7.641L104.655,146a7.1,7.1,0,0,0,6.8,6.523l24.638.971a7.082,7.082,0,0,0,7.3-6.016l.64-4.185Z",
    transform: "translate(10550.271 13837.146)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349",
    "data-name": "Rectangle 1349",
    width: 24.969,
    height: 15.724,
    transform: "translate(10662.979 13949.789)",
    fill: "#8c8c8c",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1350",
    "data-name": "Rectangle 1350",
    width: 24.969,
    height: 8.112,
    transform: "translate(10662.979 13953.599)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    "data-name": "Path 6794",
    d: "M122.2,143.989h.655a.177.177,0,0,1,.184.191v9.8a.177.177,0,0,1-.184.191H122.2a.176.176,0,0,1-.191-.191v-4.413a.066.066,0,0,0-.074-.074h-4.6a.066.066,0,0,0-.074.074v4.413a.176.176,0,0,1-.191.191h-.655a.169.169,0,0,1-.184-.191v-9.826a.169.169,0,0,1,.184-.191h.655a.177.177,0,0,1,.191.191V148.5a.066.066,0,0,0,.074.074h4.611a.066.066,0,0,0,.074-.074v-4.347a.177.177,0,0,1,.184-.162Z",
    transform: "translate(10546.581 13827.202)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    "data-name": "Path 6795",
    d: "M128.757,153.212a6.368,6.368,0,0,1-.2-1.787,6.685,6.685,0,0,1,.184-1.772,3.023,3.023,0,0,1,5.685,0,6.42,6.42,0,0,1,.206,1.787,6.347,6.347,0,0,1-.206,1.787,3,3,0,0,1-5.67,0Zm4.707-.309a6.657,6.657,0,0,0,.118-1.471,6.238,6.238,0,0,0-.118-1.471,1.942,1.942,0,0,0-3.743,0,6.4,6.4,0,0,0-.118,1.471,6.243,6.243,0,0,0,.118,1.471,1.942,1.942,0,0,0,3.743,0Z",
    transform: "translate(10543.319 13826.223)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6796",
    "data-name": "Path 6796",
    d: "M139.66,153.947v-9.8a.177.177,0,0,1,.191-.191h.655a.177.177,0,0,1,.184.191v9.8a.177.177,0,0,1-.184.191h-.655a.177.177,0,0,1-.191-.191Z",
    transform: "translate(10540.382 13827.201)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6797",
    "data-name": "Path 6797",
    d: "M149.358,150.1v4.839a.177.177,0,0,1-.191.191h-.655a.177.177,0,0,1-.191-.191v-.522c0-.059-.044-.088-.088,0a3.06,3.06,0,0,1-2.265.853,2.108,2.108,0,0,1-2.4-2.118c0-1.522,1.1-2.353,2.993-2.353h1.684a.066.066,0,0,0,.074-.074V150.1a1.471,1.471,0,0,0-1.7-1.6c-.912,0-1.508.382-1.669.993a.169.169,0,0,1-.221.14l-.735-.081c-.11,0-.184-.059-.169-.162.184-1.059,1.265-1.787,2.758-1.787C148.38,147.629,149.358,148.63,149.358,150.1Zm-1.059,2.64v-1.118a.066.066,0,0,0-.074-.074H146.7c-1.265,0-2.125.537-2.125,1.471s.735,1.294,1.6,1.294C147.277,154.329,148.3,153.778,148.3,152.741Z",
    transform: "translate(10539.348 13826.238)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025",
    transform: "translate(-202.679 80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6798",
    "data-name": "Path 6798",
    d: "M368.981,205.67H388.6a14.952,14.952,0,0,1,14.952,14.952v5.523l9.774-.375-9.8,6.4v4.141a14.959,14.959,0,0,1-14.952,14.959H368.952A14.959,14.959,0,0,1,354,236.309V220.622a14.952,14.952,0,0,1,14.981-14.952Z",
    transform: "translate(10493.679 13810.876)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    d: "M388.3,243.6h.655a.177.177,0,0,1,.184.184v9.8a.176.176,0,0,1-.184.191H388.3a.176.176,0,0,1-.191-.191v-4.413a.066.066,0,0,0-.074-.074h-4.6a.066.066,0,0,0-.074.074v4.413a.176.176,0,0,1-.191.191h-.655a.176.176,0,0,1-.191-.191v-9.8a.177.177,0,0,1,.191-.184h.655a.177.177,0,0,1,.191.184v4.347a.066.066,0,0,0,.074.074h4.6a.066.066,0,0,0,.074-.074v-4.347a.177.177,0,0,1,.191-.184Z",
    transform: "translate(10476.187 13800.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6800",
    "data-name": "Path 6800",
    d: "M399.609,252.879a.169.169,0,0,1,.25-.088l.419.235c.1.059.147.147.088.243a2.839,2.839,0,0,1-2.7,1.589,2.684,2.684,0,0,1-2.721-1.817,5.649,5.649,0,0,1-.279-2.008,6.7,6.7,0,0,1,.132-1.684,2.751,2.751,0,0,1,2.809-2.081,2.714,2.714,0,0,1,2.9,2.5,7.625,7.625,0,0,1,.088,1.471.169.169,0,0,1-.191.184h-4.648a.066.066,0,0,0-.074.074,4.652,4.652,0,0,0,.088,1.066,1.875,1.875,0,0,0,1.971,1.419A1.993,1.993,0,0,0,399.609,252.879Zm-3.8-3.346a4.1,4.1,0,0,0-.118.993.066.066,0,0,0,.074.074H399.5a.066.066,0,0,0,.066-.074,7.587,7.587,0,0,0-.081-.934,1.817,1.817,0,0,0-1.875-1.419,1.721,1.721,0,0,0-1.8,1.361Z",
    transform: "translate(10472.922 13799.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6801",
    "data-name": "Path 6801",
    d: "M405.52,253.58v-9.8a.176.176,0,0,1,.191-.184h.655a.169.169,0,0,1,.184.184v9.8a.169.169,0,0,1-.184.191h-.655a.177.177,0,0,1-.191-.191Z",
    transform: "translate(10470.049 13800.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6802",
    "data-name": "Path 6802",
    d: "M410.11,253.58v-9.8a.177.177,0,0,1,.184-.184h.655a.177.177,0,0,1,.191.184v9.8a.176.176,0,0,1-.191.191h-.655a.177.177,0,0,1-.184-.191Z",
    transform: "translate(10468.835 13800.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    d: "M414.575,252.842a6.28,6.28,0,0,1-.206-1.787,6.618,6.618,0,0,1,.191-1.772,3.023,3.023,0,0,1,5.685,0,6.443,6.443,0,0,1,.2,1.787,6.3,6.3,0,0,1-.2,1.787,3,3,0,0,1-5.67,0Zm4.707-.3a6.772,6.772,0,0,0,.118-1.471,6.272,6.272,0,0,0-.118-1.471,1.942,1.942,0,0,0-3.743,0,6.434,6.434,0,0,0-.118,1.471,6.354,6.354,0,0,0,.118,1.471,1.942,1.942,0,0,0,3.743,0Z",
    transform: "translate(10467.708 13799.866)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1351",
    "data-name": "Rectangle 1351",
    width: 24.969,
    height: 15.724,
    transform: "translate(10859.845 14023.069)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1352",
    "data-name": "Rectangle 1352",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14023.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14025.452)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1354",
    "data-name": "Rectangle 1354",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14027.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1355",
    "data-name": "Rectangle 1355",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14030.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14032.594)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1357",
    "data-name": "Rectangle 1357",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14034.977)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1358",
    "data-name": "Rectangle 1358",
    width: 24.969,
    height: 1.522,
    transform: "translate(10859.978 14037.359)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1359",
    "data-name": "Rectangle 1359",
    width: 12.106,
    height: 8.377,
    transform: "translate(10859.845 14023.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6804",
    "data-name": "Path 6804",
    d: "M384.658,215.5l.11.235.235.037-.169.184.037.257-.213-.118-.206.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.657 13808.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6805",
    "data-name": "Path 6805",
    d: "M384.658,217.61l.11.235.235.037-.169.184.037.257-.213-.125-.206.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.657 13807.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6806",
    "data-name": "Path 6806",
    d: "M384.658,219.71l.11.235.235.037-.169.184.037.257-.213-.125-.206.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.657 13807.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M384.658,221.81l.11.235.235.044-.169.176.037.257-.213-.118-.206.118.037-.257-.169-.176.235-.044Z",
    transform: "translate(10475.657 13806.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M384.658,223.92l.11.235.235.037-.169.184.037.257-.213-.125-.206.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.657 13806.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    "data-name": "Path 6809",
    d: "M386.166,216.73l.1.235.235.037-.169.184.037.257-.206-.118-.213.118.037-.257L385.82,217l.235-.037Z",
    transform: "translate(10475.261 13807.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6810",
    "data-name": "Path 6810",
    d: "M386.166,218.84l.1.235.235.037-.169.184.037.257-.206-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.261 13807.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6811",
    "data-name": "Path 6811",
    d: "M386.166,220.94l.1.235.235.037-.169.184.037.257-.206-.118-.213.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.261 13806.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6812",
    "data-name": "Path 6812",
    d: "M386.166,223.04l.1.235.235.037-.169.184.037.257-.206-.118-.213.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10475.261 13806.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6813",
    "data-name": "Path 6813",
    d: "M387.666,215.5l.11.235.235.037-.177.184.044.257-.213-.118-.213.118.044-.257-.177-.184.243-.037Z",
    transform: "translate(10474.863 13808.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6814",
    "data-name": "Path 6814",
    d: "M387.666,217.61l.11.235.235.037-.177.184.044.257-.213-.125-.213.125.044-.257-.177-.184.243-.037Z",
    transform: "translate(10474.863 13807.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6815",
    "data-name": "Path 6815",
    d: "M387.666,219.71l.11.235.235.037-.177.184.044.257-.213-.125-.213.125.044-.257-.177-.184.243-.037Z",
    transform: "translate(10474.863 13807.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6816",
    "data-name": "Path 6816",
    d: "M387.666,221.81l.11.235.235.044-.177.176.044.257-.213-.118-.213.118.044-.257-.177-.176.243-.044Z",
    transform: "translate(10474.863 13806.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6817",
    "data-name": "Path 6817",
    d: "M387.666,223.92l.11.235.235.037-.177.184.044.257-.213-.125-.213.125.044-.257-.177-.184.243-.037Z",
    transform: "translate(10474.863 13806.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6818",
    "data-name": "Path 6818",
    d: "M389.176,216.73l.1.235.235.037-.169.184.037.257-.206-.118-.213.118.037-.257L388.83,217l.235-.037Z",
    transform: "translate(10474.464 13807.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6819",
    "data-name": "Path 6819",
    d: "M389.176,218.84l.1.235.235.037-.169.184.037.257-.206-.125-.213.125L389,219.3l-.169-.184.235-.037Z",
    transform: "translate(10474.464 13807.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M389.176,220.94l.1.235.235.037-.169.184.037.257-.206-.118-.213.118L389,221.4l-.169-.184.235-.037Z",
    transform: "translate(10474.464 13806.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M389.176,223.04l.1.235.235.037-.169.184.037.257-.206-.118-.213.118L389,223.5l-.169-.184.235-.037Z",
    transform: "translate(10474.464 13806.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M390.676,215.5l.1.235.235.037-.169.184.044.257-.213-.118-.213.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10474.067 13808.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6823",
    "data-name": "Path 6823",
    d: "M390.676,217.61l.1.235.235.037-.169.184.044.257-.213-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10474.067 13807.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6824",
    "data-name": "Path 6824",
    d: "M390.676,219.71l.1.235.235.037-.169.184.044.257-.213-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10474.067 13807.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6825",
    "data-name": "Path 6825",
    d: "M390.676,221.81l.1.235.235.044-.169.176.044.257-.213-.118-.213.118.037-.257-.169-.176.235-.044Z",
    transform: "translate(10474.067 13806.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6826",
    "data-name": "Path 6826",
    d: "M390.676,223.92l.1.235.235.037-.169.184.044.257-.213-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10474.067 13806.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6827",
    "data-name": "Path 6827",
    d: "M392.178,216.73l.11.235.235.037-.169.184.037.257-.213-.118-.213.118.044-.257L391.84,217l.235-.037Z",
    transform: "translate(10473.668 13807.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6828",
    "data-name": "Path 6828",
    d: "M392.178,218.84l.11.235.235.037-.169.184.037.257-.213-.125-.213.125.044-.257-.169-.184.235-.037Z",
    transform: "translate(10473.668 13807.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6829",
    "data-name": "Path 6829",
    d: "M392.178,220.94l.11.235.235.037-.169.184.037.257-.213-.118-.213.118.044-.257-.169-.184.235-.037Z",
    transform: "translate(10473.668 13806.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6830",
    "data-name": "Path 6830",
    d: "M392.178,223.04l.11.235.235.037-.169.184.037.257-.213-.118-.213.118.044-.257-.169-.184.235-.037Z",
    transform: "translate(10473.668 13806.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6831",
    "data-name": "Path 6831",
    d: "M393.686,215.5l.1.235.235.037-.169.184.037.257-.206-.118-.213.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10473.271 13808.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6832",
    "data-name": "Path 6832",
    d: "M393.686,217.61l.1.235.235.037-.169.184.037.257-.206-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10473.271 13807.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6833",
    "data-name": "Path 6833",
    d: "M393.686,219.71l.1.235.235.037-.169.184.037.257-.206-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10473.271 13807.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6834",
    "data-name": "Path 6834",
    d: "M393.686,221.81l.1.235.235.044-.169.176.037.257-.206-.118-.213.118.037-.257-.169-.176.235-.044Z",
    transform: "translate(10473.271 13806.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6835",
    "data-name": "Path 6835",
    d: "M393.686,223.92l.1.235.235.037-.169.184.037.257-.206-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10473.271 13806.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6836",
    "data-name": "Path 6836",
    d: "M395.186,216.73l.1.235.243.037-.176.184.044.257-.213-.118-.213.118.044-.257L394.84,217l.243-.037Z",
    transform: "translate(10472.874 13807.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6837",
    "data-name": "Path 6837",
    d: "M395.186,218.84l.1.235.243.037-.176.184.044.257-.213-.125-.213.125.044-.257-.177-.184.243-.037Z",
    transform: "translate(10472.874 13807.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6838",
    "data-name": "Path 6838",
    d: "M395.186,220.94l.1.235.243.037-.176.184.044.257-.213-.118-.213.118.044-.257-.177-.184.243-.037Z",
    transform: "translate(10472.874 13806.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6839",
    "data-name": "Path 6839",
    d: "M395.186,223.04l.1.235.243.037-.176.184.044.257-.213-.118-.213.118.044-.257-.177-.184.243-.037Z",
    transform: "translate(10472.874 13806.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6840",
    "data-name": "Path 6840",
    d: "M396.688,215.5l.11.235.235.037-.169.184.037.257-.213-.118-.206.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.475 13808.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6841",
    "data-name": "Path 6841",
    d: "M396.688,217.61l.11.235.235.037-.169.184.037.257-.213-.125-.206.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.475 13807.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6842",
    "data-name": "Path 6842",
    d: "M396.688,219.71l.11.235.235.037-.169.184.037.257-.213-.125-.206.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.475 13807.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6843",
    "data-name": "Path 6843",
    d: "M396.688,221.81l.11.235.235.044-.169.176.037.257-.213-.118-.206.118.037-.257-.169-.176.235-.044Z",
    transform: "translate(10472.475 13806.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6844",
    "data-name": "Path 6844",
    d: "M396.688,223.92l.11.235.235.037-.169.184.037.257-.213-.125-.206.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.475 13806.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6845",
    "data-name": "Path 6845",
    d: "M398.2,216.73l.1.235.235.037-.169.184.044.257-.213-.118-.213.118.037-.257L397.85,217l.235-.037Z",
    transform: "translate(10472.078 13807.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6846",
    "data-name": "Path 6846",
    d: "M398.2,218.84l.1.235.235.037-.169.184.044.257-.213-.125-.213.125.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.078 13807.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6847",
    "data-name": "Path 6847",
    d: "M398.2,220.94l.1.235.235.037-.169.184.044.257-.213-.118-.213.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.078 13806.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6848",
    "data-name": "Path 6848",
    d: "M398.2,223.04l.1.235.235.037-.169.184.044.257-.213-.118-.213.118.037-.257-.169-.184.235-.037Z",
    transform: "translate(10472.078 13806.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6849",
    "data-name": "Path 6849",
    d: "M399.7,215.5l.11.235.235.037-.169.184.037.257-.213-.118-.213.118.044-.257-.169-.184.235-.037Z",
    transform: "translate(10471.679 13808.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6850",
    "data-name": "Path 6850",
    d: "M399.7,217.61l.11.235.235.037-.169.184.037.257-.213-.125-.213.125.044-.257-.169-.184.235-.037Z",
    transform: "translate(10471.679 13807.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6851",
    "data-name": "Path 6851",
    d: "M399.7,219.71l.11.235.235.037-.169.184.037.257-.213-.125-.213.125.044-.257-.169-.184.235-.037Z",
    transform: "translate(10471.679 13807.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6852",
    "data-name": "Path 6852",
    d: "M399.7,221.81l.11.235.235.044-.169.176.037.257-.213-.118-.213.118.044-.257-.169-.176.235-.044Z",
    transform: "translate(10471.679 13806.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6853",
    "data-name": "Path 6853",
    d: "M399.7,223.92l.11.235.235.037-.169.184.037.257-.213-.125-.213.125.044-.257-.169-.184.235-.037Z",
    transform: "translate(10471.679 13806.048)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027",
    transform: "translate(-16 25.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6854",
    "data-name": "Path 6854",
    d: "M140.55,230.281H127.657a25.219,25.219,0,1,0,1.2,7.6v-.566Z",
    transform: "translate(10556.584 13809.006)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6855",
    "data-name": "Path 6855",
    d: "M95.312,256.339a18.2,18.2,0,0,1-1.537,2.273,7.311,7.311,0,0,0-.625-.787,21.778,21.778,0,0,0,3.5-7.075l1.206.36c-.059.147-.184.177-.346.162a31.7,31.7,0,0,1-1.383,3.442l.419.118c0,.088-.1.162-.287.169v9.245h-.949Zm9.951.353c.118-.537.265-1.353.39-2.14h-2.89v8.487c0,1.044-.375,1.236-2.412,1.236a3.9,3.9,0,0,0-.36-1h1.567c.191,0,.25-.059.25-.25v-8.472H99.468A12.826,12.826,0,0,1,98,257.3a3.94,3.94,0,0,0-.735-.6,15.731,15.731,0,0,0,2.4-5.92l1.206.324c0,.1-.125.162-.316.147a22.629,22.629,0,0,1-.735,2.383h6.935a25.366,25.366,0,0,1-.655,3.192Zm-4.648.478c-.044.1-.147.162-.324.162a14.268,14.268,0,0,1-2.206,4.854,4.634,4.634,0,0,0-.772-.5,13.194,13.194,0,0,0,2.125-4.869Zm5.273,4.9a20.137,20.137,0,0,0-1.993-5.016l.86-.3a19.429,19.429,0,0,1,2.067,4.964Z",
    transform: "translate(10552.686 13798.95)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6856",
    "data-name": "Path 6856",
    d: "M118.118,253.79l.552.14-.088.206a19,19,0,0,1-1.4,6.251,10.239,10.239,0,0,1,1.728,1.581l-.6.8a9.864,9.864,0,0,0-1.552-1.515,7.862,7.862,0,0,1-2.876,3.037,4.531,4.531,0,0,0-.61-.8,6.869,6.869,0,0,0,2.729-2.831,19.214,19.214,0,0,0-1.655-1.118l-.177.64-.831-.434c.368-1.28.816-3.126,1.236-5H113.11v-.919h1.655c.235-1.088.434-2.133.61-3.067l1.191.147c0,.1-.1.162-.287.177-.162.831-.368,1.772-.581,2.743h2.206Zm-2.618.956c-.309,1.353-.64,2.714-.949,3.905.61.338,1.236.735,1.846,1.155a17.092,17.092,0,0,0,1.206-5.06Zm11.091,2.5v.941h-3.508V263c0,1.118-.434,1.294-3.008,1.265a4.934,4.934,0,0,0-.36-.971h1.743c.493,0,.64,0,.64-.309v-4.825h-3.56v-.941h3.56v-2.471h.478a14.708,14.708,0,0,0,2.155-2.368h-5.6v-.919h6.332l.191-.059.772.485a.471.471,0,0,1-.235.14,18.254,18.254,0,0,1-3.111,3.361v1.8Z",
    transform: "translate(10547.405 13798.947)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1360",
    "data-name": "Rectangle 1360",
    width: 24.969,
    height: 15.724,
    transform: "translate(10647.785 14029.438)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6857",
    "data-name": "Path 6857",
    d: "M99.109,224.46l.61,1.228,1.346.191-.978.956.235,1.339-1.213-.632-1.206.632.235-1.339-.978-.956,1.346-.191Z",
    transform: "translate(10551.625 13805.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6858",
    "data-name": "Path 6858",
    d: "M104.778,223.81l.316.632.691.1-.5.485.118.691-.625-.324-.618.324.118-.691-.507-.485.7-.1Z",
    transform: "translate(10549.876 13806.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6859",
    "data-name": "Path 6859",
    d: "M105.928,228.15l.309.632.7.1-.507.493.118.691-.618-.324-.625.324.118-.691-.5-.493.691-.1Z",
    transform: "translate(10549.572 13804.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6860",
    "data-name": "Path 6860",
    d: "M103.108,230.99l.309.625.7.1-.5.493.118.691-.625-.331-.618.331.118-.691-.507-.493.7-.1Z",
    transform: "translate(10550.318 13804.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6861",
    "data-name": "Path 6861",
    d: "M99.2,232.29l.309.625.7.1-.5.493.118.691-.625-.324-.618.324.118-.691-.507-.493.7-.1Z",
    transform: "translate(10551.353 13803.834)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32",
    transform: "translate(10667.521 14083.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6862",
    "data-name": "Path 6862",
    d: "M277.713,144.506A30.506,30.506,0,0,0,247.206,114h-10.62a30.506,30.506,0,0,0-30.507,30.506",
    transform: "translate(-145.786 -114)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    y1: 22.593,
    transform: "translate(131.927 30.506)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y2: 22.593,
    transform: "translate(60.294 30.506)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6863",
    "data-name": "Path 6863",
    d: "M207.574,232.285s1.9,13.3,1.522,16.724-1.14,6.84-10.642,3.037-26.6,3.045-37.626,16.342-31.919,57.77-31.919,63.087,4.177,12.5,11.767,13.679,25.461-20.519,25.461-20.519,7.6,42.943,7.6,46.333-3.405,25.844-3.405,25.844H277.883L273.7,369.071l7.6-61.189s31.543,42.943,38.383,44.862,17.482-1.522,20.144-9.5-1.522-16.342-6.847-22.424-38.758-59.667-44.863-64.6-23.181-5.325-29.264-3.8-16.342,3.8-19,2.28-2.655-15.959,0-22.424C239.875,232.285,216.693,238.367,207.574,232.285Z",
    transform: "translate(-125.371 -145.288)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6864",
    "data-name": "Path 6864",
    d: "M215.67,389.63a38.5,38.5,0,0,0,3.743,1.228",
    transform: "translate(-148.323 -186.918)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6865",
    "data-name": "Path 6865",
    d: "M189,356.48s1.692,14.768,15.606,22.5",
    transform: "translate(-141.268 -178.148)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 7.399,
    y2: 10.811,
    transform: "translate(91.014 135.08)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y1: 4.074,
    x2: 1.956,
    transform: "translate(164.176 141.339)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6866",
    "data-name": "Path 6866",
    d: "M341.195,304.63l-5.075,22.424,6.237-13.01",
    transform: "translate(-180.188 -164.431)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6867",
    "data-name": "Path 6867",
    d: "M374,357.718s8.031-5.148,15.937-5.148",
    transform: "translate(-190.209 -177.114)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6868",
    "data-name": "Path 6868",
    d: "M349.772,374.727a109.589,109.589,0,0,0,14.555-9.428,32.565,32.565,0,0,1,23.167-6.56c7.582.816,11.686,10.245,11.885,19.681s-4.92,15.165-14.143,16.6-20.092-.61-26.851-2.25a89.091,89.091,0,0,0-10.87-2.052S338.7,377.183,349.772,374.727Z",
    transform: "translate(-182.323 -178.7)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6869",
    "data-name": "Path 6869",
    d: "M406.251,378.419c-.2-9.436-4.3-18.864-11.885-19.681A32.565,32.565,0,0,0,371.2,365.3l-1.03.787c8.825.3,26.667,3.905,23.873,28.55C402.044,392.716,406.442,387.163,406.251,378.419Z",
    transform: "translate(-189.196 -178.7)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6870",
    "data-name": "Path 6870",
    d: "M234.611,232.277s1.9,13.3,1.522,16.724c-.287,2.567-.787,5.148-5.023,4.648,6.06,9.907,23.659,33.161,40.082,1.471a8.859,8.859,0,0,1-4.28-.456c-2.655-1.522-2.655-15.959,0-22.424C266.912,232.277,243.73,238.359,234.611,232.277Z",
    transform: "translate(-152.408 -145.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6871",
    "data-name": "Path 6871",
    d: "M235.87,232.29s.493,3.457.927,7.3a33.676,33.676,0,0,0,14.268,3.883,27.55,27.55,0,0,0,15.525-4.494,27.5,27.5,0,0,1,1.581-6.685S244.99,238.372,235.87,232.29Z",
    transform: "translate(-153.667 -145.294)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 11.422,
    height: 27.168,
    rx: 5.711,
    transform: "translate(54.557 41.001)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6872",
    "data-name": "Path 6872",
    d: "M206.789,169.78H204.45V196.9h2.339Z",
    transform: "translate(-145.355 -128.757)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1362",
    "data-name": "Rectangle 1362",
    width: 11.422,
    height: 27.168,
    rx: 5.711,
    transform: "translate(126.426 41.001)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6873",
    "data-name": "Path 6873",
    d: "M304.519,169.78H302.18V196.9h2.339Z",
    transform: "translate(-171.209 -128.757)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6874",
    "data-name": "Path 6874",
    d: "M166.41,198.413a5.361,5.361,0,0,0-4.258,2.839c-1.706,2.839-7.1,13.341-6.531,16.467s24.13,25.263,24.13,26.682-18.732,26.969-31.227,38.324-22.424,24.123-24.13,34.346,4.258,18.732,10.51,20.438,13.907-1.986,22.7-13.062,32.933-59.329,36.625-75.751c0,0,.846-7.355-2.559-11.642s-11.922-14.194-11.922-14.194,1.706-19.585.287-21-2.839,1.706-2.839,1.706-1.316-6.568-3.126-6.251c-1.978.353-2.552,2.839-2.552,2.839S170.1,194.435,166.41,198.413Z",
    transform: "translate(-124.098 -135.959)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6875",
    "data-name": "Path 6875",
    d: "M194.967,205.87s-4.074,16.3-3.677,19.056",
    transform: "translate(-141.866 -138.304)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6876",
    "data-name": "Path 6876",
    d: "M186.768,201.23s-4.317,15.856-4.869,18.063a5.435,5.435,0,0,0,.691,4.273",
    transform: "translate(-139.345 -137.077)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6877",
    "data-name": "Path 6877",
    d: "M179.437,198.92s-6.1,17-6.1,18.8a9.353,9.353,0,0,0,1.383,3.993",
    transform: "translate(-137.125 -136.466)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6878",
    "data-name": "Path 6878",
    d: "M160.982,295.53a149.617,149.617,0,0,1-12.459,13.238c-12.5,11.348-22.424,24.123-24.13,34.346s4.258,18.732,10.51,20.438,13.907-1.986,22.7-13.062c5.067-6.369,15.2-25.049,23.6-42.9C168.41,304.194,163.13,298.9,160.982,295.53Z",
    transform: "translate(-124.098 -162.024)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6879",
    "data-name": "Path 6879",
    d: "M213.442,142.459s-.493,39.516.993,46.929,14.819,20,30.153,20.5,27.418-13.584,28.9-21,0-37.045-.243-48.9-17.29-22.475-34.566-19.762S212.456,133.067,213.442,142.459Z",
    transform: "translate(-147.713 -115.534)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6880",
    "data-name": "Path 6880",
    d: "M262.745,172.44s.985,6.913,1.978,8.391,2.714,3.464-.735,4.942-6.178-.25-6.178-1.978",
    transform: "translate(-159.471 -129.46)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6881",
    "data-name": "Path 6881",
    d: "M262.629,204.177S249.288,205.884,243.36,200c0,0,1.471,9.142,5.928,10.627S262.629,204.177,262.629,204.177Z",
    transform: "translate(-155.649 -136.751)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 1.236,
    y2: 3.949,
    transform: "translate(89.69 43.222)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M238.66,177.81s3.457,2.206,9.877.243",
    transform: "translate(-154.405 -130.881)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x2: 1.236,
    y2: 3.949,
    transform: "translate(113.893 43.222)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6883",
    "data-name": "Path 6883",
    d: "M271.57,177.81s3.457,2.206,9.884.243",
    transform: "translate(-163.112 -130.881)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M236.31,161.5a12.959,12.959,0,0,1,10.37-5.185",
    transform: "translate(-153.784 -125.196)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6885",
    "data-name": "Path 6885",
    d: "M268.55,155.52s7.163-1.971,12.105,3.677",
    transform: "translate(-162.313 -124.896)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6886",
    "data-name": "Path 6886",
    d: "M248.7,168.781h0a6.825,6.825,0,0,1-.088,7.046l-.14.221a11.5,11.5,0,0,1-9.759,5.42h-1.544a8.964,8.964,0,0,1-7.751-4.463v0a7.443,7.443,0,0,1-.427-6.619h0a7.428,7.428,0,0,1,6.384-4.538l7.031-.441A6.8,6.8,0,0,1,248.7,168.781Z",
    transform: "translate(-151.694 -127.596)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6887",
    "data-name": "Path 6887",
    d: "M266.663,168.781h0a6.825,6.825,0,0,0,.088,7.046l.14.221a11.5,11.5,0,0,0,9.759,5.42H278.2a8.965,8.965,0,0,0,7.751-4.463v0a7.421,7.421,0,0,0,.427-6.619h0a7.428,7.428,0,0,0-6.384-4.538l-7.024-.441A6.818,6.818,0,0,0,266.663,168.781Z",
    transform: "translate(-161.566 -127.596)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6888",
    "data-name": "Path 6888",
    d: "M257.13,171.484s2.206-1.728,6.421,0",
    transform: "translate(-159.291 -129.004)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x2: 12.106,
    transform: "translate(94.875 38.78)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x1: 11.554,
    transform: "translate(65.729 42.781)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6889",
    "data-name": "Path 6889",
    d: "M257.664,132.082s6.4,20.548,16.114,25.858c-.213-7.046-.463-13.665-.552-17.952-.25-11.855-17.29-22.475-34.566-19.762s-26.182,12.841-25.2,22.233c0,0-.081,6.45-.074,14.635C221.73,153.5,243.69,143.481,257.664,132.082Z",
    transform: "translate(-147.72 -115.534)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4020",
    "data-name": "Group 4020",
    transform: "translate(65.669 4.264)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6890",
    "data-name": "Path 6890",
    d: "M211.14,152.08s32.4-13.584,49.908-30.83",
    transform: "translate(-212.794 -120.182)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6891",
    "data-name": "Path 6891",
    d: "M207.58,138s33.97-7.84,53.57-28.484",
    transform: "translate(-211.852 -117.079)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6892",
    "data-name": "Path 6892",
    d: "M282.19,124.44s.522,13.326,14.635,25.608",
    transform: "translate(-231.591 -121.026)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6894",
    "data-name": "Path 6894",
    d: "M272.787,232.357s0,8.958-6.715,23.233-7,28.55-2.523,39.185,16.518,14.841,29.418,10.083,14.555-26.035,13.157-38.913-13.974-27.991-16.8-35.552-4.758-11.473-4.758-11.473S277.288,229,272.8,231.231Z",
    transform: "translate(-160.195 -141.757)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4021",
    "data-name": "Group 4021",
    transform: "translate(100.352 77.163)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6895",
    "data-name": "Path 6895",
    d: "M280.616,223.57a70.316,70.316,0,0,1-4.7,36.037c-7.84,18.813-1.831,38.935,7.318,43.112s18.026,2.618,22.468-3.133",
    transform: "translate(-263.655 -220.15)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6896",
    "data-name": "Path 6896",
    d: "M288.23,217.89s8.884,20.9,5.229,36.581-2.089,35.574,8.884,39.457,17.246-3.883,17.246-3.883",
    transform: "translate(-267.871 -218.647)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6897",
    "data-name": "Path 6897",
    d: "M302.8,236.36s7.575,28.741,7.575,43.634,9.149,12.547,11.5,5.229",
    transform: "translate(-271.725 -223.534)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6899",
    "data-name": "Path 6899",
    d: "M272.787,232.357s0,8.958-6.715,23.233-7,28.55-2.523,39.185,16.518,14.841,29.418,10.083,14.555-26.035,13.157-38.913-13.974-27.991-16.8-35.552-4.758-11.473-4.758-11.473S277.288,229,272.8,231.231Z",
    transform: "translate(-160.195 -141.757)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1363",
    "data-name": "Rectangle 1363",
    width: 55.424,
    height: 73.619,
    rx: 5.19,
    transform: "translate(95.571 167.757) rotate(2.31)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6900",
    "data-name": "Path 6900",
    d: "M336.4,377.971s-24.446-7.6-28.616-8.884S279.6,385.745,278.641,388.3s2.559,2.567,2.559,2.567-1.471,2.559.735,3.839a13.236,13.236,0,0,0,2.206,1.2s-1.28,2.883,1.28,3.846,6.09-1.6,6.09-1.6l5.766-4.163s-6.928,8.48-5.45,10.252c2.037,2.427,3.339-.177,3.339-.177l7.965-9.436,8-3.846s6.406,3.846,16.658,4.163,12.5-4.163,12.5-4.163",
    transform: "translate(-164.938 -181.466)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6901",
    "data-name": "Path 6901",
    d: "M286.25,400.085s8.98-6.163,11.216-8.392,9.48-6.884,11.716-6.884",
    transform: "translate(-166.995 -185.643)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6902",
    "data-name": "Path 6902",
    d: "M304.11,400.27s4.413-4.986,6.075-5.729,4.089-1.861,4.089-1.861",
    transform: "translate(-171.72 -187.725)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6903",
    "data-name": "Path 6903",
    d: "M282.18,393.148s12.5-8.825,16.783-11.422a60.432,60.432,0,0,1,7.994-4.1",
    transform: "translate(-165.918 -183.743)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.2a7b395beae6f8e56bead31217f97cd0.svg";
export { ForwardRef as ReactComponent };